import React from 'react';

const VideoSkeleton = ({ viewMode = 'grid' }) => {
  if (viewMode === 'list') {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-4 animate-pulse">
        <div className="flex items-center space-x-4">
          {/* Thumbnail skeleton */}
          <div className="w-24 h-16 bg-gray-200 rounded-lg flex-shrink-0" />
          
          {/* Content skeleton */}
          <div className="flex-1 space-y-2">
            <div className="h-5 bg-gray-200 rounded w-3/4" />
            <div className="h-4 bg-gray-200 rounded w-1/2" />
            <div className="h-4 bg-gray-200 rounded w-2/3" />
            <div className="h-3 bg-gray-200 rounded w-1/3" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden animate-pulse">
      {/* Thumbnail skeleton */}
      <div className="aspect-video bg-gray-200" />
      
      {/* Content skeleton */}
      <div className="p-4 space-y-3">
        <div className="h-5 bg-gray-200 rounded w-3/4" />
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded w-1/2" />
          <div className="h-4 bg-gray-200 rounded w-2/3" />
          <div className="h-3 bg-gray-200 rounded w-1/3" />
        </div>
      </div>
    </div>
  );
};

const SkeletonGrid = ({ viewMode = 'grid' }) => {
  const skeletonCount = viewMode === 'list' ? 6 : 8;
  
  return (
    <div className={`
      ${viewMode === 'grid' && 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6'}
      ${viewMode === 'list' && 'space-y-4'}
      ${viewMode === 'masonry' && 'columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-6 space-y-6'}
    `}>
      {[...Array(skeletonCount)].map((_, index) => (
        <div key={index} className={viewMode === 'masonry' ? 'break-inside-avoid' : ''}>
          <VideoSkeleton viewMode={viewMode} />
        </div>
      ))}
    </div>
  );
};

export default SkeletonGrid;